import ExternalSouce from 'rer-theme/components/Blocks/Listing/Extra/ExternalSource';

export const appyBlockExtraTags = (config) => {
  const templatesExtraForNewsItem = [
    'SimpleCardDefault',
    'CardWithImageDefault',
    'CardWithSlideUpTextTemplate',
    'CompleteBlockLinksTemplate',
    'ContentInEvidenceTemplate',
    'RibbonCardTemplate',
    'SimpleCardTemplateOneForRow',
    'HighlightedContent',
  ];

  templatesExtraForNewsItem.forEach((template) => {
    config.registerComponent({
      name: 'BlockExtraTags',
      component: ExternalSouce,
      dependencies: [template, 'ExternalNews'],
    });
  });
};
